// Every slide is laid out at this size. The fixed layout scales the stage into its box, so the slide's container
// queries always see 1280px and a small preview never reflows to the phone column. Marks drawn on a slide are kept
// in these units, so they land on the same words in every window.
export const STAGE_WIDTH = 1280;
export const STAGE_HEIGHT = 720;
